// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","textbox":"footer-module--textbox--22W1p"};